import type { ResourceEndpoints } from '../core'

/** Every URL of the users API, in one place. */
export const usersEndpoints = {
  collection: '/api/v1/users',
  item: (id: string) => `/api/v1/users/${encodeURIComponent(id)}`,
} satisfies ResourceEndpoints
